import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {
  CRUD_CREATE_FAILURE,
  CRUD_CREATE_SUCCESS,
  CRUD_DELETE_FAILURE,
  CRUD_DELETE_SUCCESS,
  CRUD_GET_LIST_FAILURE,
  CRUD_GET_MANY_FAILURE,
  CRUD_GET_MANY_REFERENCE_FAILURE,
  CRUD_GET_ONE_FAILURE,
  CRUD_UPDATE_FAILURE,
  CRUD_UPDATE_SUCCESS,
  CRUD_GET_META_FAILURE,
  CREATE_AND_UPDATE_SUCCESS,
  CREATE_AND_UPDATE_FAILURE,
  CRUD_EXPORT_SUCCESS,
  CRUD_EXPORT_FAILURE
} from 'actions/dataActions';
import { showNotification } from 'actions/notificationActions';
import linkToRecord from 'util/linkToRecord';

import { loginFrontendPath } from 'routes/auth';
import {clearCrudResourceData} from "actions";

/**
 * Side effects for fetch responses
 *
 * Mostly redirects and notifications
 */
function* handleResponse({ type, requestPayload, error, payload, meta }) {
  switch (type) {
    case CRUD_UPDATE_SUCCESS:
      return requestPayload.redirect ? yield [
        put(showNotification(meta.notification || 'Updated')),
        put(push(requestPayload.redirectPath)),
      ] : yield [put(showNotification(meta.notification || 'Updated'))];
    case CRUD_CREATE_SUCCESS:
      // Custom message instead of 'created'
      if (typeof payload === 'object') {
        if (typeof payload.data === 'object') {
          if (typeof payload.data.message === 'string') {
              return requestPayload.redirect ? yield [
                  put(showNotification(payload.data.message)),
                  put(push(requestPayload.redirectPath)),
              ] : yield [put(showNotification(payload.data.message))];
          }
        }
      }
      return requestPayload.redirect ? yield [
        put(showNotification('Created')),
        put(push(requestPayload.redirectPath)),
      ] : yield [put(showNotification('Created'))];
    case CREATE_AND_UPDATE_SUCCESS:
      return requestPayload.redirect ? yield [
        put(showNotification('Created')),
        put(push(linkToRecord(requestPayload.redirectPath, payload.data.id))),
      ] : yield [put(showNotification('Created'))];
    case CRUD_DELETE_SUCCESS:
      return requestPayload.redirect ? yield [
        put(showNotification('aor.notification.deleted')),
        put(push(requestPayload.basePath)),
      ] : yield [put(showNotification('aor.notification.deleted'))];
    case CRUD_EXPORT_SUCCESS:
      return yield [put(showNotification('The data has been exported successfully, please check in a few minutes. Email: '+ localStorage.getItem('username')))]
    case CRUD_GET_ONE_FAILURE:
    case CRUD_GET_LIST_FAILURE:
    case CRUD_GET_MANY_FAILURE:
    case CRUD_GET_MANY_REFERENCE_FAILURE:
    case CRUD_CREATE_FAILURE:
    case CREATE_AND_UPDATE_FAILURE:
    case CRUD_UPDATE_FAILURE:
    case CRUD_GET_META_FAILURE:
    case CRUD_EXPORT_FAILURE:
    case CRUD_DELETE_FAILURE: {
      console.error(error);
      const errorMessage = typeof error === 'string'
        ? error
        : (error.message || 'HTTP Error');
      if (meta.httpStatus === 401) {
        return yield [
          put(showNotification(errorMessage, 'warning')),
          put(push(loginFrontendPath)),
        ];
      }
      if (
        type === CRUD_CREATE_FAILURE
        || type === CRUD_UPDATE_FAILURE
      ) {
        return yield [
          put(showNotification(errorMessage, 'warning')),
        ];
      } else {
        return yield [
          put(showNotification(errorMessage, 'warning')),
          put(clearCrudResourceData(meta.resource)),
        ];
      }
    }
    default:
      return yield [];
  }
}

export default function*() {
  yield takeEvery(action => action.meta && action.meta.fetchResponse, handleResponse);
}



// WEBPACK FOOTER //
// ./src/sideEffect/saga/crudResponse.js